import { NAVY_ACTION } from "./shared";

const STAGE_STYLE = {
  "Contract Review":  { bg: "#ede9fe", border: "#c4b5fd", label: "#5b21b6", text: "#3b0764" },
  "Pending Number":   { bg: "#fef3c7", border: "#fcd34d", label: "#92400e", text: "#78350f" },
  "Numbered":         { bg: "#dbeafe", border: "#93c5fd", label: "#1e40af", text: "#1e3a8a" },
  "Active":           { bg: "#dbeafe", border: "#93c5fd", label: "#1e40af", text: "#1e3a8a" },
  "In Progress":      { bg: "#dbeafe", border: "#93c5fd", label: "#1e40af", text: "#1e3a8a" },
  "Package Complete": { bg: "#d1fae5", border: "#6ee7b7", label: "#065f46", text: "#064e3b" },
};

export default function NextActionBanner({
  next,
  isMobile,
  submittingJobNumber,
  completePct,
  sections,
  onPrint,
  onSubmitJobNumber,
  goToSection,
  sharePointFolderUrl,
}) {
  if (!next) return null;

  if (next.isDone) {
    return (
      <div style={{ marginTop: 4, padding: "10px 14px", background: "#d1fae5", borderRadius: 8, border: "1px solid #6ee7b7", fontSize: 13, fontWeight: 600, color: "#065f46" }}>
        ✅ Turnover complete — no further action needed
      </div>
    );
  }

  const style = STAGE_STYLE[next.stage] || { bg: "#f3f4f6", border: "#d1d5db", label: "#374151", text: "#111827" };

  return (
    <div style={{
      marginTop: 4, padding: isMobile ? "12px 14px" : "12px 16px",
      background: style.bg, border: `1px solid ${style.border}`,
      borderRadius: 8, display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "stretch" : "center",
      gap: isMobile ? 10 : 14,
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 9, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.08em", color: style.label, marginBottom: 3 }}>
          Next Required Action
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: style.text }}>
          {next.owner && <span>{next.owner}&nbsp;—&nbsp;</span>}{next.action}
        </div>
        {next.reason && (
          <div style={{ fontSize: 12, color: style.text, opacity: 0.8, marginTop: 2 }}>
            {next.reason}
          </div>
        )}
        {next.stage === "Package Complete" && (
          <div style={{ fontSize: 11, color: style.text, opacity: 0.7, marginTop: 4 }}>
            New release? Open the section (e.g. §3) and click ✓ Complete to reopen it.
            {sharePointFolderUrl && (
              <> &nbsp;·&nbsp; <a href={sharePointFolderUrl} target="_blank" rel="noreferrer" style={{ color: style.text, fontWeight: 600 }}>Open in SharePoint ↗</a></>
            )}
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0, width: isMobile ? "100%" : "auto" }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: completePct === 100 ? "#10b981" : style.text, flexShrink: 0 }}>
          {completePct}%
        </div>
        {next.ctaAction === "print" && (
          <button
            onClick={onPrint}
            style={{ flex: isMobile ? 1 : "none", padding: "9px 18px", fontSize: 13, fontWeight: 700, background: NAVY_ACTION, color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", whiteSpace: "nowrap" }}
          >
            {next.ctaLabel}
          </button>
        )}
        {next.ctaAction === "submit_job_number" && (
          <button
            onClick={onSubmitJobNumber}
            disabled={submittingJobNumber}
            style={{ flex: isMobile ? 1 : "none", padding: "9px 18px", fontSize: 13, fontWeight: 700, background: NAVY_ACTION, color: "#fff", border: "none", borderRadius: 6, cursor: submittingJobNumber ? "default" : "pointer", opacity: submittingJobNumber ? 0.6 : 1, whiteSpace: "nowrap" }}
          >
            {submittingJobNumber ? "Submitting…" : next.ctaLabel}
          </button>
        )}
        {!next.ctaAction && next.targetSection && (() => {
          const targetSec   = sections.find(s => s.SectionNumber === next.targetSection);
          const targetLabel = targetSec ? targetSec.SectionName : `Section ${next.targetSection}`;
          return (
            <button
              onClick={() => goToSection(next.targetSection)}
              style={{ flex: isMobile ? 1 : "none", padding: "9px 18px", fontSize: 13, fontWeight: 700, background: NAVY_ACTION, color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", whiteSpace: "nowrap" }}
            >
              Next: {targetLabel} →
            </button>
          );
        })()}
      </div>
    </div>
  );
}
